import { GtmEvent, GtmEventValue, TrackingService } from "../../Tracking/Scripts/Services/tracking-service";

export class HeaderTracking {


    public setTrackUniverseHeaderClick() {
        const universeHeaderTitles = document.querySelectorAll('.js-universe-slider');

        universeHeaderTitles.forEach((universeHeader) => {
            var universeHeaderLink = universeHeader.querySelector('.header-menu-item') as HTMLAnchorElement;
            if (universeHeaderLink) {
                const linkId = universeHeaderLink.getAttribute("data-uid")?? '0';
                universeHeaderLink.addEventListener('click', () => this.TrackUniverseHeaderClick(linkId));
            }
        })
    }

    private TrackUniverseHeaderClick(id: string) {
        var data = {
            name: id,
            type: GtmEventValue.Universe,
            value: GtmEventValue.Header
        }
        TrackingService.logEvent(GtmEvent.ClickMenu, data);
        
    }    
}